// Path: ./src/app/components/LanguageGroupButton/index.tsx
/**
 *
 * LanguageGroupButton
 *
 */
import React, { memo, useEffect, useState } from "react";
import { FlagLogo } from "../FlagLogo";
import CanLogo from "../../assets/can.png";
import CnLogo from "../../assets/cn.png";
import { useTranslation } from "react-i18next";
import {
  AppLanguage,
  isEnglishLanguage,
  setLanguagePreference,
} from "../../../utils/langPreference";
import { ButtonGroup, LeftButton, RightButton, ButtonText } from "./styled";

export const LanguageGroupButton = memo(() => {
  const { i18n } = useTranslation();
  const [selectLanguage, setSelectLanguage] = useState(() =>
    isEnglishLanguage(i18n.language),
  );

  useEffect(() => {
    const syncLanguage = (lang: string) => {
      setSelectLanguage(isEnglishLanguage(lang));
    };

    syncLanguage(i18n.language);
    i18n.on("languageChanged", syncLanguage);

    return () => {
      i18n.off("languageChanged", syncLanguage);
    };
  }, [i18n]);

  const applyLanguage = (lang: AppLanguage) => {
    setLanguagePreference(lang);
    void i18n.changeLanguage(lang);
  };

  return (
    <ButtonGroup>
      <LeftButton
        onClick={() => applyLanguage("en")}
        active={selectLanguage}
        data-testid="english-language-button"
      >
        <FlagLogo url={CanLogo} />
        <ButtonText>EN</ButtonText>
      </LeftButton>
      <RightButton
        onClick={() => applyLanguage("zh")}
        active={selectLanguage}
        data-testid="chinese-language-button"
      >
        <FlagLogo url={CnLogo} />
        <ButtonText>CN</ButtonText>
      </RightButton>
    </ButtonGroup>
  );
});
